import {
  TMenhirSpotlights,
  TSpotlights,
} from '@/common/integrations/menhir/employee/spotlights/spotlights.types';

export const transformSpotlights = (
  spotlights: TMenhirSpotlights
): TSpotlights => {
  return {
    insurance: spotlights.insurance && {
      upgradePeriod: spotlights.insurance.upgrade_period && {
        limitDate: spotlights.insurance.upgrade_period.limit_date,
        active: spotlights.insurance.upgrade_period.active,
      },
    },
  };
};
